<template>
  <div>
    <el-radio-group v-model="radio1" @change="filterDate()">
      <el-radio-button label="1">今日</el-radio-button>
      <el-radio-button label="2">昨日</el-radio-button>
      <el-radio-button label="7">7天內</el-radio-button>
      <el-radio-button label="30">30天內</el-radio-button>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  data() {
    return {
      radio1: 1,
    }
  },
  methods: {
    filterDate() {
      this.$emit('filterDate', this.radio1)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/element_ui/TimeRadioButton.vue